"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const useCombinedRefs_1 = __importDefault(require("../hooks/useCombinedRefs"));
const inputStyle = {
    height: '100%',
    width: '100px',
    borderRadius: '5px',
    border: '0.55px solid #c7c7c7',
    textAlign: 'center',
};
const NumberInput = (0, react_1.forwardRef)(({ name, value: valueProp, style = {}, onChange, pattern = '^\\d*.\\d*$', step = 'any', min = 'any', max = 'any', autoSelect = false, ...otherProps }, ref) => {
    const combinedRef = (0, useCombinedRefs_1.default)([ref]);
    (0, react_1.useEffect)(() => {
        if (autoSelect) {
            combinedRef?.current?.select();
        }
    }, [autoSelect, combinedRef]);
    return ((0, jsx_runtime_1.jsx)("input", { ref: combinedRef, name: name, style: { ...inputStyle, ...style }, type: "number", pattern: pattern, value: valueProp, step: step, onChange: onChange, min: min, max: max, ...otherProps }));
});
exports.default = NumberInput;
